export enum CodingOptimizationMode {
    HIDE_ENCOUNTER_AND_DX = 1,
    HIDE_DX = 2,
    SHOW_ALL = 3,
}
